<script setup lang="ts">
import { useProgressStore } from '@/stores/progress';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

const progressStore = useProgressStore();
const { isLoading, progress } = storeToRefs(progressStore);
const { t } = useI18n();
</script>

<template>
    <Transition name="progress-fade">
        <div
            v-if="isLoading"
            class="z-9999999999 fixed left-0 right-0 top-0 h-1 overflow-hidden bg-transparent"
            role="progressbar"
            :aria-label="t('common.loading')"
            :aria-valuenow="progress"
            aria-valuemin="0"
            aria-valuemax="100"
        >
            <div
                class="h-full shadow-lg transition-all duration-300 ease-out"
                :style="{
                    width: `${progress}%`,
                    background: 'linear-gradient(to right, rgb(234 179 8), rgb(202 138 4), rgb(234 179 8))',
                }"
            >
                <!-- Animated shimmer effect -->
                <div
                    class="animate-shimmer absolute inset-0"
                    style="
                        background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.3), transparent);
                        background-size: 200% 100%;
                    "
                ></div>
            </div>
        </div>
    </Transition>
</template>

<style scoped>
.progress-fade-enter-active {
    transition: opacity 0.2s ease-out;
}

.progress-fade-leave-active {
    transition: opacity 0.4s ease-in;
}

.progress-fade-enter-from,
.progress-fade-leave-to {
    opacity: 0;
}

@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }
    100% {
        background-position: 200% 0;
    }
}

.animate-shimmer {
    animation: shimmer 2s infinite;
}
</style>
